// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f130c8fc","264":"7da16065","480":"c9cb7fd7","484":"005a171b","551":"52a7b25b","570":"581aba58","638":"dbc42657","738":"445f500e"}[chunkId] + ".chunk.js";
};